import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import CardLayout from "../../components/utils/CardLayout";
import genericActions from "../../redux/generic/actions";
import { useDispatch, useSelector } from "react-redux";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import rechargeActions from "../../redux/recharge/actions";
import ToastAlert from "../../components/utils/ToastAlert";
import authActions from "../../redux/auth/actions";

const { singleRechargeReq, resetMessage } = rechargeActions;
const { getPlan } = genericActions;
const { getUserDataByToken } = authActions;

const SingleRecharge = () => {
  const dispatch = useDispatch();
  const { planList, getPlanLoading } = useSelector((state) => state.generic);
  const { singleRechargeLoading, singleRechargeMessage, singleRechargeError, } = useSelector((state) => state.recharge);
  const [selectedPlan, setSelectedPlan] = useState({})


  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      planId: "",
      months: 1,
      mobileNumber: "",
    },
  });

  const watchPlanId = watch('planId');

  useEffect(() => {
    if (watchPlanId) {
      const planData = planList.find(
        (item) => item?.PlanID == watchPlanId
      );
      setSelectedPlan(planData);
    }
  }, [watchPlanId, planList]);


  useEffect(() => {
    dispatch(getPlan({ ActionType: 2, Month: 1 }))
    return () => {
      dispatch(resetMessage());
    };
  }, [])

  useEffect(() => {
    if (singleRechargeMessage) {
      ToastAlert({ type: "success", text: singleRechargeMessage });
      handleReset();
      dispatch(getUserDataByToken());
    }

    if (singleRechargeError) {
      ToastAlert({ type: "error", text: singleRechargeError });
    }
  }, [singleRechargeMessage, singleRechargeError]);


  const onSubmit = (data) => {
    const payload = {
      "planId": Number(data?.planId),
      "months": Number(data?.months),
      "rechargeType": 2,
      "items": [
        {
          "mobileNumber": data?.mobileNumber
        }
      ]
    }

    dispatch(singleRechargeReq(payload))

    // Call Recharge API here
  };

  const handleReset = () => {
    reset({ planId: "", mobileNumber: "" });
    setSelectedPlan({})
  };

  return (
    <CardLayout
      title='Recharge'
      icon="ri-flashlight-line"
    >
      <div className="row">
        {/* Left Side */}
        <div className="col-lg-3 left-panel">
          <div className="quick-links">
            <div className="d-flex justify-content-between">
              <button type="button" onClick={() => { }}>
                <h5 className="quick-title">Plan Summary</h5>
                {<div className="title-line"></div>}
              </button>
            </div>

            <div className="d-flex flex-column gap-3">

              {/* <div className="d-flex align-items-center justify-content-between 
                  border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-tag text-primary"></i>
                  <span className="text-dark fw-semibold">Plan Price</span>
                </div>

                <span className="text-primary fw-bold">${twoDigitDecimal(selectedPlan?.PlanAmount)}</span>
              </div> */}

              <div className="d-flex align-items-center justify-content-between 
                  border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-hand-holding-dollar text-primary"></i>
                  <span className="text-dark fw-semibold">Dealer Cost</span>
                </div>

                <span className="text-primary fw-bold">${twoDigitDecimal(selectedPlan?.DealerCost)}</span>
              </div>

              {selectedPlan?.PlanCode && <div className="d-flex justify-content-between ">
                <div className="d-flex align-items-center gap-2">
                  <small className="mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>SKU</small>
                </div>
                <span className="text-primary fw-semibold" style={{ fontSize: "13px", }}>{selectedPlan?.PlanCode}</span>
              </div>}

              {selectedPlan?.PlanDesc && <div className="">
                <div className="d-flex align-items-center gap-2">
                  <small className="mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>Plan Description</small>
                </div>
                <span className="text-primary fw-semibold" style={{ fontSize: "13px", }}>{selectedPlan?.PlanDesc}</span>
              </div>}
            </div>

          </div>
        </div>

        {/* Right Side */}
        <div className="col-lg-9">
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            <div className="row">

              {/* MSISDN Number */}
              <div className="col-lg-4 mb-2">
                <label className="form-label fw-semibold">
                  MSISDN <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.mobileNumber ? "is-invalid" : ""
                    }`}
                  placeholder="MSISDN"
                  maxLength={10}
                  {...register("mobileNumber", {
                    required: "MSISDN is required",
                    minLength: {
                      value: 10,
                      message: "MSISDN must be 10 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  }}
                />

                <div className="invalid-feedback"> {errors.mobileNumber?.message} </div>
              </div>


              {/* Plan */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Plan <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-select ${errors.planId ? "is-invalid" : ""
                    }`}
                  disabled={getPlanLoading}
                  {...register("planId", {
                    required: "Plan is required",
                  })}
                >

                  <>
                    <option value="">Select Plan</option>
                    {planList?.map((item) => (
                      <option key={item?.PlanID} value={item?.PlanID}>
                        {item?.PlanName}
                      </option>
                    ))}
                  </>
                </select>

                <div className="invalid-feedback"> {errors.planId?.message} </div>
              </div>



              {/* Months */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Month <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-control ${errors.months ? "is-invalid" : ""
                    }`}
                  disabled
                  {...register("months", {
                    required: "Month is required",
                  })}
                >
                  <>
                    <option value="">Select Month</option>
                    <option value="1">1</option>
                  </>
                </select>

                <div className="invalid-feedback"> {errors.months?.message} </div>
              </div>

              {/* Submit */}
              <div
                className="d-flex justify-content-end mt-3 gap-2"
              >
                <Button
                  buttonType="button"
                  title="Reset"
                  disable={singleRechargeLoading}
                  variant="secondary"
                  icon={<i className="ri-refresh-line me-1"></i>}
                  onClick={handleReset}
                />

                <Button
                  buttonType="submit"
                  title="Recharge"
                  loading={singleRechargeLoading}
                  icon={<i className="ri-flashlight-line me-1"></i>}
                />
              </div>

            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};
export default SingleRecharge;
